import gql from 'graphql-tag';

export const GET_SITEINI_LIST_BY_LICENSE = gql`
  query ($licenseId: ID!){
    siteiniListByLicense(license_id: $licenseId) {
      site
      channels {
        id
        xmltv_id
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/graphql/queries/siteini/listByLicense.js